import { Component, EventEmitter, Input, OnDestroy, Output, signal } from "@angular/core";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { StoreRepositoryService } from "../../store/store-repository.service";

@Component({
  selector: 'app-syndicate-jackpot-trigger',
  templateUrl: './syndicate-jackpot-trigger.component.html',
  styleUrl: './syndicate-jackpot-trigger.component.scss',
  standalone: true,
  imports: [IonicModule, TranslatePipe]
})
export class SyndicateJackpotTriggerComponent implements OnDestroy {
  selectedLanguage: string = CommonVariable.preferredLanguage;
  public spanish: boolean;
  @Output() showJackpotExpandViewEvent = new EventEmitter<void>();
  @Output() opentriggerInfoEvent = new EventEmitter<void>();
  @Input() childProperty1?;
  public syndicateData: Data;
  private syndicateDataSubscription: Subscription;
  JackpotpotTriggerActiveCount = signal(0);
  JackpotpotTriggerSubscription : Subscription;
  constructor(
    private authService: AuthService,
    public translate: TranslateService,
    private syndicateDataService: SyndicateDataService,
    private storeService: StoreRepositoryService,
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );

    // To fetch data to bind on the template
    this.syndicateDataSubscription = this.syndicateDataService?.getSyndicatePageData()?.subscribe({
      next: (data) => {
        this.syndicateData = data;
      },
      error: (err) => {
        return err;
      },
    });

    this.JackpotpotTriggerSubscription = this.storeService?.jackpotActivatedCount$?.subscribe((count) => {
      this.JackpotpotTriggerActiveCount.set(count);
    });
  }

  showJackpotExpandView(event) {
    this.showJackpotExpandViewEvent.emit(event);
  }

  opentriggerInfo(event) {
    this.opentriggerInfoEvent.emit(event);
  }

  ngOnDestroy(): void {
    this.syndicateDataSubscription?.unsubscribe();
    this.JackpotpotTriggerSubscription?.unsubscribe();
  }

}
